import { memo } from 'react';

import { RootState } from 'entities/rootState';
import SiteAccordion from '../site/site-accordion';
import PdpLocale from 'locale/en/pdp.json';
import EntireWorldLocale from 'locale/en/entire-world.json';
import styled from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';
import { WithFontBody, WithSiteLayout } from 'styles/commonCss';
import { createMarkup } from 'lib/utils/create-markup';
import { mqSmallMin } from 'styled/tools/media-queries';

const sectionHeightLg = 'auto';

const SEntireWorldFaq = styled.section`
  display: block;
  background-color: #fff;
  padding: var(--spacing-48) 0;
  @media ${mqLargeMin} {
    padding: 120px 0;
  }

  * {
    color: var(--text-primary);
  }
  > .container {
    ${WithSiteLayout}
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    height: ${sectionHeightLg};
    position: relative;
  }

  .heading {
    width: 100%;
    @media ${mqLargeMin} {
      width: 30%;
    }

    .title {
      font-size: 36px;
      line-height: 1.2;

      @media ${mqLargeMin} {
        font-size: var(--font-size-1200);
      }

      * {
        font-size: 36px;
        line-height: inherit;
        font-weight: 300;

        @media ${mqLargeMin} {
          font-size: var(--font-size-1200);
        }
      }

      br {
        @media ${mqSmallMin} {
          display: none;
        }
      }
    }

    .text {
      margin: var(--spacing-24) 0 0;
      font-size: 13px;
      max-width: 80%;

      * {
        font-size: 13px;
      }
    }
  }
  .list {
    @media ${mqLargeMin} {
      margin: 0;
      width: 65%;
    }
    width: 100%;
    margin: var(--spacing-48) 0 0;
  }

  .site-accordion {
    border-color: var(--outline-neutral);
    border-right: 0;
    border-left: 0;
  }
  .site-accordion .head {
    padding: var(--font-size-300) 0;
    padding: 1.25rem 0;
  }
  .site-accordion .head .icon {
    margin: 0;
    @media ${mqLargeMin} {
      margin-right: 10px;
    }
  }
  .site-accordion .head .title {
    max-width: 90%;
  }
  .site-accordion .head .title h3 {
    ${WithFontBody}
    font-size: var(--font-size-400);
    font-weight: 500;
  }
  .site-accordion .container {
    padding: 0 0 var(--spacing-24) 0;
    border-top: 0;
  }
  .site-accordion .content {
    border-color: var(--outline-neutral);
    background: transparent;
  }
  .site-accordion .content p {
    margin: var(--spacing-8) 0 0;
    &:first-child {
      margin: 0;
    }
  }
`;

type SectionEntireWorldFaqProps = {
  title?: string;
} & RootState;

const SectionEntireWorldFaq = memo((props: SectionEntireWorldFaqProps) => {
  const { cms } = props;
  const list = cms && cms.entire_world_faq;

  const title = props.title ? props.title : PdpLocale.for_the;
  return (
    <SEntireWorldFaq>
      <div className='container'>
        <div className='heading'>
          <h2 className='title' dangerouslySetInnerHTML={createMarkup(title)} />
          <p
            className='text'
            dangerouslySetInnerHTML={createMarkup(EntireWorldLocale.cant_find)}
          />
        </div>
        <div className='list'>
          {list &&
            list.map((v, i) => {
              const val = v.fields;
              return (
                val && (
                  <SiteAccordion
                    index={i}
                    key={val.question}
                    content={val.response}
                    title={`<h3>${val.question}</h3>`}
                  />
                )
              );
            })}
        </div>
      </div>
    </SEntireWorldFaq>
  );
});

export default SectionEntireWorldFaq;
